import { Stack, StackProps, styled } from '@mui/material';

const StyledWrapper = styled(Stack)<StackProps>(({ theme }) => ({
  width: '40rem',
  height: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRight: `0.1rem solid ${theme.palette.border.main}`,
  paddingTop: '2rem',
  paddingBottom: '2rem',
  paddingLeft: '2.4rem',
  paddingRight: '1.2rem',
}));

export default StyledWrapper;
